import { render } from "./TestComponent.vue?vue&type=template&id=7faa54f7&scoped=true"
import script from "./TestComponent.vue?vue&type=script&lang=js"
export * from "./TestComponent.vue?vue&type=script&lang=js"

import "./assets/bootstrap.min.css?vue&type=style&index=0&id=7faa54f7&scoped=true&lang=css"
import "./TestComponent.vue?vue&type=style&index=1&id=7faa54f7&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faa54f7"]])

export default __exports__